import initialState from './initialState'

import {
  SET_USER_CURVE
 } from '../actions/actionTypes'

export default function userCurveReducer(state = initialState.userCurves, action) {
  switch (action.type) {
    case SET_USER_CURVE:
      return { ...state, ['usercurve-' + action.index]: [...action.curve] }

    default:
      return state
  }
}
